<template>
  <div class="flex relative">
    <div class="fixed left-0 top-0 h-screen w-1/2 z-0">
      <div class="w-full h-full overflow-hidden relative">
        <div
          class="w-full h-full absolute bg-gradient-to-b from-[#2027ED] to-black"
        ></div>
        <!-- <img
          :src="require('/assets/images/onboarding_home.webp')"
          class="w-full h-full object-cover"
        /> -->
      </div>
    </div>
    <div
      class="flex-none w-5/12 min-h-screen filter drop-shadow-2xl overflow-auto"
    >
      <div class="flex h-full items-center justify-center p-10 pb-20">
        <div>
          <div class="flex items-center justify-center mb-16">
            <img
              :src="require('/assets/images/small_mydid_white.png')"
              alt=""
              class="w-24 self-center mr-2"
            />
          </div>
          <p
            class="text-white leading-[70px] text-[60px] font-medium mb-10"
            v-html="$t('signin.sloganTxt')"
          ></p>
          <p class="text-white text-2xl" v-html="$t('signin.sloganTxtBis')"></p>
        </div>
      </div>
    </div>
    <div
      class="flex-1 min-h-screen overflow-auto z-10"
      style="padding-left: -20px"
    >
      <div
        class="flex h-full w-full border bg-gray-light shadow-md justify-center items-center rounded-l-[50px]"
      >
        <div
          class="w-96 2xl:w-[500px] text-center bg-white rounded-3xl mx-auto p-10 2xl:py-20"
        >
          <div v-if="!isSignup" class="flex justify-center mt-10">
            <img
              :src="require('/assets/images/mydid-logo-2.png')"
              alt=""
              class="w-32 self-center"
            />
          </div>
          <p v-if="emailSent" class="font-bold mt-5 mb-2">
            {{ $t('signin.emailSentTitle') }}
          </p>
          <p v-else-if="!isSignup" class="font-bold mt-5 mb-2">
            {{ $t('signin.welcomeTxt') }}
          </p>
          <p v-else class="text-xl text-center font-bold mb-10 mt-5">
            <icon name="account" class="mr-1.5" />{{ $t('signin.signupTxt') }}
          </p>
          <div v-show="!emailSent">
            <div v-if="signWithQrCode" class="my-10">
              <div
                v-if="qrCodeDataSignin && qrCodeDataSignup"
                class="flex justify-center"
              >
                <qrcode-vue
                  :value="isSignup ? qrCodeDataSignup : qrCodeDataSignin"
                  :size="100"
                  level="H"
                  :margin="1"
                />
              </div>
              <div v-else>
                <Vue3Lottie
                  :animationLink="require('/assets/images/loader-round.jpg')"
                  :height="100"
                  :width="100"
                  :speed="1.5"
                />
              </div>
              <div class="flex justify-center items-center mt-5">
                <p class="text-sm text-gray-500">{{ $t('other.scanTxt') }}</p>
              </div>
            </div>
            <div v-else class="my-10" :class="{ 'mb-5': !signWithQrCode }">
              <p class="text-start text-sm font-bold mb-2">
                {{ $t('signin.signupEmailTxt') }}
              </p>
              <div class="mb-2">
                <input
                  type="text"
                  :placeholder="$t('signin.signupEmailPlaceholder')"
                  class="w-full text-sm text-center outline-none border-gray-300 border rounded-lg px-3 py-2"
                  v-model="emailAuth"
                />
              </div>

              <button
                class="w-full text-sm text-center bg-secondary text-white shadow-sm rounded-lg cursor-pointer py-2 px-3 mb-1.5"
                @click="sendEmailAuth"
                :class="{
                  'pointer-events-none opacity-50': emailSendLoading,
                }"
              >
                {{
                  isSignup
                    ? $t('signin.useEmailTxtTer')
                    : $t('signin.useEmailTxtTerBis')
                }}
              </button>
              <div
                v-if="emailError"
                class="flex items-center justify-center gap-1"
              >
                <p
                  class="w-3 h-3 rounded-full bg-red-500 text-white text-xs flex items-center justify-center"
                >
                  i
                </p>
                <p class="text-red-500 text-xs">
                  {{ $t('signin.emailNotValid') }}
                </p>
              </div>
            </div>
            <div v-show="false" class="flex justify-center">
              <div
                ref="captchaContainer"
                class="frc-captcha mt-5"
                data-sitekey="Maybe-Strewn4-Embody-Sequence-Rising-Tilt"
                data-puzzle-endpoint="https://captcha.mydid.com/puzzle.php"
              ></div>
            </div>

            <div
              v-if="!signWithQrCode"
              class="flex w-full py-5 justify-center items-center gap-4"
            >
              <div class="grow shrink border-b"></div>
              <div class="text-center text-sm text-gray-500">
                {{ $t('signin.orTxt') }}
              </div>
              <div class="grow shrink border-b"></div>
            </div>
            <button
              @click="signWithQrCode = !signWithQrCode"
              class="w-full text-sm text-center font-medium border border-gray-300 shadow-sm rounded-lg cursor-pointer py-2 px-3"
            >
              <icon v-if="!signWithQrCode" name="qrcode" class="w-3 mr-1" />
              <icon v-else name="mail" class="w-5 mr-1" />
              {{
                !signWithQrCode
                  ? $t('signin.myDidAppTxt')
                  : isSignup
                  ? $t('signin.useEmailTxtBis')
                  : $t('signin.useEmailTxt')
              }}
            </button>
            <div
              v-if="!isSignup"
              class="flex justify-center items-center gap-1 mt-10"
            >
              <p class="text-sm text-gray-500">
                {{ $t('signin.signupInsteadTxt') }}
              </p>
              <p
                @click="checkSession() && (isSignup = true)"
                class="text-sm text-secondary font-medium cursor-pointer"
              >
                {{ $t('signin.signupInsteadTxtBis') }}
              </p>
            </div>
            <div
              v-if="isSignup"
              class="flex justify-center items-center gap-1 mt-10"
            >
              <p class="text-sm text-gray-500">
                {{ $t('signin.signinInsteadTxt') }}
              </p>
              <p
                @click="isSignup = false"
                class="text-sm text-secondary font-medium cursor-pointer"
              >
                {{ $t('signin.signinInsteadTxtBis') }}
              </p>
            </div>
          </div>
          <div v-show="emailSent">
            <p class="text-sm text-gray-500 mt-20 mb-44">
              {{ $t('signin.authMessage') }}
              <span class="font-bold">{{ emailAuth }}</span>
            </p>
            <!-- <button
              class="w-full text-sm text-center bg-secondary text-white shadow-sm rounded-lg cursor-pointer py-2 px-3 mb-2"
              @click="sendEmailAuth"
              :class="{
                'pointer-events-none opacity-50': emailResendCount > 0,
              }"
            >
              {{ $t('signin.emailResendButton') }}
              <span v-if="emailResendCount > 0">
                ({{ emailResendCount }}s)</span
              >
            </button> -->
            <button
              class="w-full text-sm font-semibold text-center bg-transparent text-blue-500 rounded-lg cursor-pointer py-2 px-3"
              @click="
                () => {
                  emailSent = false;
                  emailResendCount = 0;
                  emailAuth = null;
                  captchaSolution = null;
                  captchaWidget.reset();
                }
              "
            >
              {{ $t('signin.emailResendBackButton') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import { ref, inject, onMounted, watch, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { detect } from 'detect-browser';
import { toChecksumAddress } from 'ethereum-checksum-address';
import { WidgetInstance } from 'friendly-challenge';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();

    const api = inject('api');
    const cookies = inject('cookies');
    const store = inject('store');
    const utils = inject('utils');
    const { t } = useI18n();

    const isSignup = ref(false);
    const signWithQrCode = ref(false);
    const captchaContainer = ref();
    const captchaWidget = ref();
    const emailAuth = ref(null);
    const emailSent = ref(false);
    const emailResendCount = ref(0);
    const qrCodeDataSignin = ref(null);
    const qrCodeDataSignup = ref(null);
    const captchaSolution = ref(null);
    const emailSendLoading = ref(false);
    const emailError = ref(false);

    async function loadCaptcha() {
      if (captchaContainer.value) {
        captchaWidget.value = new WidgetInstance(captchaContainer.value, {
          doneCallback: async (solution) => {
            captchaSolution.value = solution;
          },
          errorCallback: (error) => {
            console.log('CAPTCHA error:', error);
          },
          // startMode: 'auto',
        });
      }
    }

    onMounted(() => {
      loadCaptcha();
    });
    onUnmounted(() => {
      if (captchaWidget.value) {
        captchaWidget.value.destroy();
      }
    });

    // https://docs.friendlycaptcha.com/#/widget_api

    if (route.query.new == '1') {
      isSignup.value = true;
    }

    [true, false].forEach((signup) => {
      api
        .createAuthChallenge({ signup, browser: detect().name })
        .then((res) => {
          const { challenge, dynamicLink } = res.data;
          if (signup) {
            qrCodeDataSignup.value = dynamicLink;
          } else {
            qrCodeDataSignin.value = dynamicLink;
          }

          api.waitChallengeValidation(challenge, (response) => {
            switch (response.status) {
              case 'validated':
                const token = response.token;
                const decodedToken = jwt.decode(token);
                const issuerDid = decodedToken.did;
                const currentIssuerAddress = utils.didToAddress(issuerDid);

                api
                  .isIssuerRegistered(issuerDid)
                  .then((res) => {
                    if (res.data.status) {
                      store.commit('setCurrentIssuerDid', issuerDid);
                      store.commit(
                        'setCurrentAddress',
                        toChecksumAddress(currentIssuerAddress)
                      );
                      store.commit(
                        'setCurrentPublicKeyBase58',
                        issuerDid.split(':')[2]
                      );
                      store.commit('setIsWeb2Connexion', decodedToken.web2);
                      store.commit(
                        'setConnexionEmail',
                        decodedToken.connexionEmail
                      );
                      store.commit('setIsAdmin', !decodedToken.isContributor);
                      cookies.set('token', token);
                      store.dispatch('getTemplateLists');
                      store.dispatch('getIssuerInfo');
                      router.push('/');
                    } else {
                      store.commit('resetIssuerState');
                      store.commit(
                        'setCurrentAddress',
                        toChecksumAddress(currentIssuerAddress)
                      );

                      store.commit(
                        'setCurrentPublicKeyBase58',
                        issuerDid.split(':')[2]
                      );
                      cookies.set('token_tmp', token);
                      store.commit('setIssuerConnectionDisplay', false);
                      router.push('/signup?connected=1');
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                    utils.showToastMessageError(t('other.serverError'));
                  });
                break;
              default:
                break;
            }
          });
        })
        .catch((err) => {
          if (err.response?.data?.message) {
            utils.showToastMessageError(err.response?.data?.message);
          } else {
            utils.showToastMessageError(t('other.serverError'));
          }
        });
    });

    async function sendEmailAuth() {
      emailSendLoading.value = true;
      emailError.value = false;

      // Start captcha and wait for solution
      captchaWidget.value.start();

      // Wait for the captcha solution to be set by the existing doneCallback with 5s timeout
      const startTime = Date.now();
      while (!captchaSolution.value) {
        if (Date.now() - startTime > 5000) {
          throw new Error('Captcha solution timeout');
        }
        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      if (!emailRegex.test(emailAuth.value) || !emailAuth.value) {
        // utils.showToastMessageError(t('signup.errors.emailNotValid'));
        emailError.value = true;
        emailSendLoading.value = false;
        return;
      }

      api
        .sendManagerMagicAuth({
          email: emailAuth.value.toLowerCase(),
          signup: isSignup.value,
          captchaSolution: captchaSolution.value,
        })
        .then((res) => {
          emailSent.value = true;
          emailResendCount.value = 15;
          emailSendLoading.value = false;
          const interval = setInterval(() => {
            emailResendCount.value--;
            if (emailResendCount.value < 0) {
              clearInterval(interval);
            }
          }, 1000);
        })
        .catch((err) => {
          // captchaSolution.value = null;
          emailSendLoading.value = false;
          // captchaWidget.value.reset();
          emailError.value = true;

          console.log(err);
          // if (err.response?.data?.message) {
          //   utils.showToastMessageError(err.response?.data?.message);
          // } else {
          //   utils.showToastMessageError(t('other.serverError'));
          // }
        });
    }

    function checkSession() {
      if (!cookies.get('token')) return true;
      window.location.href = '/';
    }

    return {
      router,
      isSignup,
      checkSession,
      captchaContainer,
      signWithQrCode,
      qrCodeDataSignin,
      qrCodeDataSignup,
      emailAuth,
      sendEmailAuth,
      emailSent,
      emailResendCount,
      emailSendLoading,
      captchaSolution,
      captchaWidget,
      loadCaptcha,
      emailError,
    };
  },
};
</script>
